import { ABOUT } from '@versports/ui'

/**
 * Texto del consentimiento informado del piloto. Placeholder — pendiente de
 * revisión legal antes de T0 (ver `docs/19-pilot-study.md` §8 y
 * `docs/15-backend-infra.md` §4.13). Usar EXACTO hasta que legal lo confirme.
 *
 * Vive acá y no inline en la página porque hoy lo firman dos superficies
 * distintas — el gate de `/consent` (celular del jugador, antes de un
 * cuestionario) y el paso de consentimiento del modo tablet
 * (`kit/KitConsentScreen.tsx`) — y el
 * texto que se firma tiene que ser literalmente el mismo en las dos.
 *
 * **Lo que se firma no cambió** (2026-09-09): los dos párrafos son
 * normativos y los define el whitepaper del estudio en tutito, no este
 * repo. Lo único que se agregó es el pie con los links a los textos
 * legales completos (`/legal/terminos`, `/legal/datos`, v1.0), que está
 * FUERA del bloque firmado a propósito: es una referencia, no una cláusula.
 */
export function ConsentNotice() {
  return (
    <div className="flex flex-col gap-md text-sm leading-relaxed text-text-secondary">
      <p className="m-0">
        VER SPORTS no reemplaza tratamiento psicológico, diagnóstico médico ni
        evaluación clínica. Es una herramienta de entrenamiento de habilidades
        mentales y rendimiento bajo presión.
      </p>
      <p className="m-0">
        No es terapia. No es diagnóstico. Podés interrumpir la experiencia en
        cualquier momento si te sentís incómodo. Se recolectan datos de
        desempeño/uso para personalizar tu entrenamiento. El club podrá recibir
        reportes según el consentimiento otorgado.
      </p>
      <p className="m-0 text-xs text-text-muted">
        Más detalle en los{' '}
        <a href={ABOUT.termsPath} target="_blank" rel="noreferrer">
          Términos y condiciones
        </a>{' '}
        y en la{' '}
        <a href={ABOUT.dataPolicyPath} target="_blank" rel="noreferrer">
          Política de datos
        </a>
        : qué se recolecta, quién accede, cuánto se conserva y cómo pedir
        acceso, rectificación o supresión.
      </p>
    </div>
  )
}

/** Label del botón/checkbox de aceptación. Mismo texto en las dos superficies. */
export const CONSENT_ACCEPT_LABEL = 'HE LEÍDO Y ACEPTO'
